import { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import ConcertCards from "../cards/concert/ConcertCards";
import SEO from "../common/SEO";

const Concerts = ({ concerts }) => {
  const { t, i18n } = useTranslation();
  const [activeFilter, setActiveFilter] = useState("all");
  const currentDate = new Date();

  const upcomingConcerts = concerts.filter((concert) => {
    const concertDate = new Date(concert.date);
    concertDate.setDate(concertDate.getDate() + 1);
    return concertDate >= currentDate;
  });

  const pastConcerts = concerts.filter((concert) => {
    const concertDate = new Date(concert.date);
    concertDate.setDate(concertDate.getDate() + 1);
    return concertDate < currentDate;
  });

  const sortedUpcomingConcerts = [...upcomingConcerts].sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );

  const sortedPastConcerts = [...pastConcerts].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  const totalUpcoming = sortedUpcomingConcerts.length;
  const mmiUpcoming = sortedUpcomingConcerts.filter((c) => c.season === "mmi").length;
  const otherUpcoming = sortedUpcomingConcerts.filter((c) => c.season !== "mmi").length;

  const filteredUpcomingConcerts = useMemo(() => {
    if (activeFilter === "mmi") {
      return sortedUpcomingConcerts.filter((c) => c.season === "mmi");
    }
    if (activeFilter === "other") {
      return sortedUpcomingConcerts.filter((c) => c.season !== "mmi");
    }
    return sortedUpcomingConcerts;
  }, [activeFilter, sortedUpcomingConcerts]);

  const isEnglish = (i18n.language || "it").startsWith("en");
  const pageTitle = isEnglish ? "Concerts & Events" : "Concerti & Eventi";
  const pageDesc = isEnglish
    ? "Discover the concert calendar, upcoming events, and performances of the Nuova Orchestra da Camera Ferruccio Busoni."
    : "Scopri il calendario dei concerti, le prossime date e tutti gli appuntamenti della Nuova Orchestra da Camera Ferruccio Busoni.";

  return (
    <>
      <SEO title={pageTitle} description={pageDesc} />

      <section className="section mousenormal concertcalendar">
        <div className="container">
          {totalUpcoming > 0 && (
            <div className="concert-filter-bar text-center mb-4">
              <div className="d-inline-flex flex-wrap justify-content-center gap-2 p-1 bg-light rounded-pill border">
                <button
                  type="button"
                  className={`concert-filter-pill ${activeFilter === "all" ? "active" : ""}`}
                  onClick={() => setActiveFilter("all")}
                >
                  {isEnglish ? "All Concerts" : "Tutti i Concerti"}
                  <span className="concert-filter-count">{totalUpcoming}</span>
                </button>
                <button
                  type="button"
                  className={`concert-filter-pill ${activeFilter === "mmi" ? "active" : ""}`}
                  onClick={() => setActiveFilter("mmi")}
                >
                  {isEnglish ? "Mattinate Musicali Season" : "Stagione Mattinate Musicali"}
                  <span className="concert-filter-count">{mmiUpcoming}</span>
                </button>
                <button
                  type="button"
                  className={`concert-filter-pill ${activeFilter === "other" ? "active" : ""}`}
                  onClick={() => setActiveFilter("other")}
                >
                  {isEnglish ? "Other Events & Festivals" : "Altri Eventi & Festival"}
                  <span className="concert-filter-count">{otherUpcoming}</span>
                </button>
              </div>
            </div>
          )}

          <div className="row justify-content-center">
            {filteredUpcomingConcerts.length > 0 ? (
              <ConcertCards concerts={filteredUpcomingConcerts} />
            ) : (
              <div className="col-12 text-center py-5">
                <p className="text-muted fs-5 mb-3">
                  {isEnglish
                    ? "No upcoming concerts found in this category."
                    : "Nessun concerto in programma per questa categoria."}
                </p>
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm rounded-pill px-4"
                  onClick={() => setActiveFilter("all")}
                >
                  {isEnglish ? "Show all concerts" : "Mostra tutti i concerti"}
                </button>
              </div>
            )}
          </div>
          {sortedPastConcerts.length > 0 && (
            <div className="past_concerts mt-5 pt-2">
              <div className="past-concerts-divider mb-4"></div>
              <h2 className="uppercasebold2 text-center mb-4">
                {t("concerts.past_concerts", "Concerti passati")}
              </h2>
              <div className="row justify-content-center">
                <ConcertCards concerts={sortedPastConcerts} />
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Concerts;
